import { Route } from 'react-router';
import { UserFrame, UserSidebar, UserContent } from 'Elements';
// import styles from 'partials/dashboard/dashboard.module.scss';

export const Dashboard = ({ match }) => {
	return (
		<UserFrame>
			<div className="row">
				<div className="col-lg-3 col-xl-2">
					<UserSidebar />
				</div>
				<Route path={`${match.url}/:tabId`} component={UserContent} />
			</div>
		</UserFrame>
	);
};
